/* unplugin-vue-components disabled */import { render } from "./duplicate.vue?vue&type=template&id=0255ac46&scoped=true"
import script from "./duplicate.vue?vue&type=script&lang=js"
export * from "./duplicate.vue?vue&type=script&lang=js"

import "./duplicate.vue?vue&type=style&index=0&id=0255ac46&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0255ac46"],['__file',"src/pages/share-chat/duplicate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0255ac46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0255ac46', __exports__)) {
    api.reload('0255ac46', __exports__)
  }
  
  module.hot.accept("./duplicate.vue?vue&type=template&id=0255ac46&scoped=true", () => {
    api.rerender('0255ac46', render)
  })

}


export default __exports__